import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { injectIntl } from 'react-intl';
import { format, parseISO } from 'date-fns';
import { PREMIUM_CAP_ENTITY } from 'constants/logic';
import { selectVenueClasses, selectClassDetails } from 'selectors/general';
import { withForm } from 'components/Form';
import { premiumCapModalResponse, fetchSchedulesForClass as fetchSchedulesForClassAction } from '../PremiumCaps.saga';
import PremiumCapsRuleModal from './PremiumCapsRuleModal';
import { syncValidator, submitValidator } from './PremiumCapsRuleModal.validators';

const FORM_NAME = 'add-premium-cap-modal';

const getDaysOfWeekFromClassSchedules = schedules => {
  const daysOfWeekObj = schedules.reduce((acc, { classDate, startTime }) => {
    const dateTime = parseISO(`${classDate} ${startTime}`);
    const day = format(dateTime, 'EEEE').toUpperCase();
    return { ...acc, [day]: true };
  }, {});

  return Object.keys(daysOfWeekObj);
};

const mapStateToProps = state => {
  const today = format(new Date(), 'yyyy-MM-dd');
  const initialValues = {
    ruleEntity: PREMIUM_CAP_ENTITY.SCHEDULE,
    recurrence: {
      dateStart: today,
      dateEnd: today,
      daysOfWeek: [],
      timeOfDayStart: '00:00:00',
      timeOfDayEnd: '23:45:00',
    },
    entityMetadata: {},
    displayData: {
      isOngoing: true,
      isVenueDefaultRule: true,
      isClassRule: true,
    },
  };
  const currentValues = getFormValues(FORM_NAME)(state) || initialValues;
  const {
    entityMetadata: { classId },
  } = currentValues;
  const { futureSchedules = [] } = classId ? selectClassDetails(state, classId) : {};
  const classes = selectVenueClasses(state) || [];

  return {
    classes,
    schedules: futureSchedules,
    initialValues,
    currentValues,
  };
};

const mapDispatchToProps = {
  onSubmit: premiumCapModalResponse,
  fetchSchedulesForClass: fetchSchedulesForClassAction,
  setField: change,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { fetchSchedulesForClass, setField, ...restDispatchProps } = dispatchProps;
  const setFormField = setField.bind(null, FORM_NAME);

  return {
    ...stateProps,
    ...restDispatchProps,
    ...ownProps,
    setField: setFormField,
    fetchSchedulesForClass: fetchSchedulesForClass.bind(null, getDaysOfWeekFromClassSchedules, daysOfWeek => {
      setFormField('recurrence.daysOfWeek', daysOfWeek);
      setFormField('entityMetadata.daysOfWeek', daysOfWeek);
    }),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withForm({
    name: FORM_NAME,
    syncValidator,
    submitValidator,
  }),
  injectIntl
)(PremiumCapsRuleModal);
